// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1ihj3","footer":"ChangeClinic_footer__QI4ZX"};